/**
 * autryViewsFilters
 * Attach `flatpicker` to date inputs
 */

// https://flatpickr.js.org/
import flatpickr from 'flatpickr'
import 'flatpickr/dist/themes/airbnb.css'

Drupal.behaviors.autryViewsFilters = {
  attach: function (context, settings) {
    const elements = once('autryViewsFilters', '.autry-views-filters', context)
    elements.forEach(el => {
      const fields = el.querySelectorAll('.bef-datepicker')
      Array.from(fields).forEach(field => {
        flatpickr(field, {
          altInput: true,
          altFormat: 'F j, Y', // January 31, 2023
          dateFormat: 'm/d/Y' // 01/31/2023
          // minDate: 'today'
        })
      })
    })
  }
}
